import React from 'react'

const UrlButton = ({ label, url }) => {
    return (
        <a
            href={url}
            target="_blank"
            rel="noreferrer noopener"
            className="bg-green-600 text-main-white px-3 py-2 rounded transition-colors duration-300 hover:bg-green-500 focus:outline-none focus:ring focus:ring-green-400 flex items-center justify-center w-10"
        >
            {label}
        </a>
    )
}

export default UrlButton